import { fetchJourney, handleTicket, fetchUser } from "#shared/utils/journey"
import { findSelectedGuideAndGroupName } from "@/lib/game"
import { useOnboardingStore } from "@/stores/onboarding"

export default defineNuxtPlugin(async ({ _route }) => {
  // msw is used only for development and testing
  // we use a facade to tree-shake msw and its dependencies for production builds
  const { worker } = await import("../msw-facade")
  await worker.start({ onUnhandledRequest: "bypass" })

  const lifecycleStore = useLifecycleStore()

  const routeName = (_route.name as string) || ""

  // Do not execute the plugin logic for static pages
  if (routeName.startsWith("static-")) {
    lifecycleStore.setInitialized(true)
    return
  }

  await handleTicket()
  await fetchUser()
  await fetchJourney() // prefetch journey
  await useContent() // prefetch content

  // WDD
  await cleanUpOnboardingAfterHandleTicket()
  await setGuideIdAndGroupName()

  lifecycleStore.setInitialized(true)
})

const setGuideIdAndGroupName = async () => {
  const journeyData = useJourneyStore().journeyData
  if (journeyData) {
    const guideAndGroup = findSelectedGuideAndGroupName(journeyData)
    if (!guideAndGroup) return
    const { guideId, groupName } = guideAndGroup
    const onboardingStore = useOnboardingStore()
    if (!guideId || !groupName) return
    onboardingStore.setGuideId(guideId)
    onboardingStore.setGroupName(groupName)
    onboardingStore.complete()
  }
}

const cleanUpOnboardingAfterHandleTicket = async () => {
  const onboardingStore = useOnboardingStore()

  const search = window.location.search
  const searchParams = new URLSearchParams(search)
  const ticketId = searchParams.get("ticket_id")

  if (ticketId) {
    onboardingStore.$reset()
    window.setTimeout(() => {
      const url = new URL(window.location.href)
      url.searchParams.delete("ticket_id")
      window.history.replaceState(null, "", url.toString())
    }, 1000)
  }
}
